import { v4 as uuidv4 } from "uuid";
import mUtils from "@/modules/utils";
//import { ORDER_TYPE } from "@/modules/enums";

export default {
  state: {
    order: {
      orderType: "",
      tableID: 0,
      tableName: "",
      tableGroupID: 0,
      tableGroupName: "",
      phoneID: "",
      memberCode: "",
      memberVip: false,
      login: null,
      orderItems: [],
      currency: "",
      subtotal: 0,
      defaultDiscountRate: 0,
      defaultServiceValue: 0,
      defaultServicePercentage: true,      
      deliveryQuoteValue: 0,
      deliveryValue: 0,      
      deliveryWithhold: 0,
      discountRate: 0,
      discountValue: 0,
      tax: 0,
      tips: 0,
      total: 0,
      qtyTotal: 0,
      catQtyTotal: [],
      redeemedPointsTotal: 0,
      payAmount: 0,
      payData: {},
      address: {},
      dineInAway: false,
      checkoutTime: null,
      pickupTime: null,
      deliveryTime: null,
      memo: null,
      minOrder: 0,
      minOrderForFreeDelivery: 0,
      utensils: false,
      priceLevel: 0,
      distance: 0,
      payment: "",
      lastUpdated: new Date(),
      cbRefIDs: [],
      paymentTips: [],
      orderNow: true,
    },

    //orderedCounter: [],
    ordDidCount: 1,
    orderPin: undefined,
  },

  getters: {
    orderItemDescriptionByLang: (state, getters, rootState) => oi => {
      if (!oi) return "";

      if (rootState.descrIndex == 1) return oi.ord_descr1;
      else if (rootState.descrIndex == 2) return oi.ord_descr2;
      else return oi.ord_descr;
    },

    orderItemPrice: () => oi => {
      if (oi == null) return 0;

      return oi.price;
    },

    orderItemSub: (state, getters) => oi => {
      if (oi == null) return 0;
      let sub =
        (oi.item && oi.item.scalable ? getters.orderItemPrice(oi) * oi.item.weight : getters.orderItemPrice(oi)) +
        oi.optionValue +
        oi.bAdj;
      return sub;
    },

    orderItemDiscountedSub: (state, getters) => oi => {
      if (oi == null) return 0;
      let discSub = getters.orderItemSub(oi);
      if (oi.itemDiscountable) {
        if (oi.itemDiscountRate > 0) {
          if (oi.optionDiscountable) discSub = discSub * (1 - oi.itemDiscountRate / 100);
          else discSub = (discSub - oi.optionValue) * (1 - oi.itemDiscountRate / 100) + oi.optionValue;
        }
      }
      return discSub;
    },

    orderItemTotal: (state, getters) => oi => {
      if (oi == null) return 0;
      return oi.qty * getters.orderItemSub(oi);
    },

    orderItemDiscountTotal: (state, getters) => oi => {
      if (oi == null) return 0;
      let value = 0;
      if (oi.itemDiscountable) {
        if (oi.itemDiscountRate > 0) {
          let discountableSub = getters.orderItemSub(oi);
          if (!oi.optionDiscountable) {
            discountableSub -= oi.optionValue;
          }
          value = oi.qty * mUtils.roundNumber(discountableSub * (oi.itemDiscountRate / 100), 2);
        } else value = oi.itemDiscountValue;
      } else value = 0;

      return value;
    },

    orderItemExtended: (state, getters) => oi => {
      if (oi == null) return 0;
      return getters.orderItemTotal(oi) - getters.orderItemDiscountTotal(oi);
    },

    orderDepositAmount: (state, getters) => {
      if (getters.paymentDeposit == null) {
        return 0;
      } else {
        let value = 0;
        let percentage = false;
        if (getters.paymentDeposit.value) value = getters.paymentDeposit.value;
        //if (getters.paymentDeposit.percentage) percentage = getters.paymentDeposit.percentage === true;
        percentage = getters.paymentDeposit.percentage === true;
        if (value == 0) return 0;
        else if (!percentage) return value;
        else {
          return state.order.total * (value / 100);
        }
      }
    },

    orderPayAmount: (state, getters) => {
      if (getters.orderDepositAmount == 0) return state.order.total + state.order.tips;
      else return getters.orderDepositAmount;
    },

    // 
    /*
    itemOrderedQty: (state) => item => {
      if (item == null) return 0;
      let qty = 0;
      let ele = state.orderedCounter.find(ele => ele.ID == item.ID);
      if (ele) qty = ele.qty;
      return qty;
    }, 
    */

    orderCatQtyTotal: (state) => (cat) => {
      let qtyTotal = 0;
      let orderItems;
      if (cat) {
        orderItems = state.order.orderItems.filter((x) => x.item.catID == cat.ID && x.item.catKey == cat.key);
      } else orderItems = state.order.orderItems;

      orderItems.forEach((x) => {
        qtyTotal += x.qty;
      });
      return qtyTotal;
    },    

    orderItemQtyTotal: (state) => (item) => {
      let qtyTotal = 0;
      let orderItems;
      if (item) {
        orderItems = state.order.orderItems.filter((x) => x.ID == item.ID && x.key == item.key);
      } else orderItems = state.order.orderItems;

      orderItems.forEach((x) => {
        qtyTotal += x.qty;
      });
      return qtyTotal;
    },   
    
    orderPinRequired: (state, getters, rootState) => {
      if (rootState.appData) {
        return rootState.appData.pinRequired === true;
      }
    },

    orderDeliveryAddressString: (state) => {
      if (state.order.address) return mUtils.addressToString(state.order.address);
      else return undefined;
    }
  },

  mutations: {
    ORDER_CLEAR(state) {
      //console.log("clearOrder");
            
      state.order.orderUUID = uuidv4();
      state.order.orderBy = null;
      state.order.orderItems = [];
      state.order.subtotal = 0;
      state.order.deliveryQuoteValue = 0;      
      state.order.deliveryValue = 0;
      state.order.deliveryWithhold = 0;
      state.order.discountRate = 0;
      state.order.discountValue = 0;
      state.order.serviceRate = 0;
      state.order.serviceValue = 0;
      state.order.tax = 0;
      state.order.tips = 0;
      state.order.total = 0;
      state.order.qtyTotal = 0;
      state.order.catQtyTotal = [];
      state.order.redeemedPointsTotal = 0;
      state.order.payAmount = 0;
      state.order.payData = null;
      state.order.address = null;
      state.order.dineInAway = false;
      state.order.checkoutTime = null;
      state.order.pickupTime = null;
      state.order.deliveryTime = null;
      state.order.deliveryTimeTo = null;
      state.order.memo = "";
      //state.order.utensils = undefined;
      state.order.alwaysSendPickupTime = false;
      state.order.distance = 0;
      state.order.lastUpdated = Date.now();
      state.order.cbRefIDs = [];

      state.order.doorDash = undefined;

      state.ordDidCount = 1;      
    },

    ORDER_ORDER_BY(state, payload) {
      state.order.orderBy = payload;
    },

    ORDER_ORDER_ITEMS(state, payload) {
      state.order.orderItems = payload;
    }    
  },

  actions: { 
    ORDER_SEND_MESSAGE(context, message) {
      let currentTableID = context.state.order.tableID;

      if (!message || !currentTableID) return;

      const wshost = "wss://wss.mrsdigi.com:8080/notify";
      let wsConnect = new WebSocket(wshost);
      if (wsConnect) {
        wsConnect.onopen = () => {
          console.log(message);
          wsConnect.send(
            `{"publish":{"channel":"DIGI-ORDER:${context.getters.storeCompanyCode}", "data":{"service":"${message}", "tableID":${currentTableID}}}}`
          );
          wsConnect.close();
        };
      }
    },
  },
};
